export const caseCategories = [
  {
    value: 'Cadastral and Land Registration Cases',
    label: 'Cadastral and Land Registration Cases',
  },
  {
    value: 'Civil Cases',
    label: 'Civil Cases',
  },
  {
    value: 'Criminal Cases',
    label: 'Criminal Cases',
  },
  {
    value: 'Environmental Cases',
    label: 'Environmental Cases',
  },
  {
    value: 'Others',
    label: 'Others',
  },
  {
    value: 'Special Civil Actions',
    label: 'Special Civil Actions',
  },
  {
    value: 'Special Proceedings',
    label: 'Special Proceedings',
  },
];
